;(() => {
  const node = document.getElementById('astari-referral-pilot-config')
  if (!node) return
  let config
  try { config = JSON.parse(node.textContent) } catch (_error) { return }
  const theme = window.Shopify?.theme
  const attribute = '__astari_referral_claim'
  const canonicalCode = 'ASTARI-LHR63RQJ'
  const configuredGeneral = config.resolverMode === 'general'
  if (config.resolverMode !== undefined && !['pilot', 'general'].includes(config.resolverMode)) return
  const configuredEndpoint = `https://astari-affiliates.vercel.app/api/referral/${configuredGeneral ? 'resolve-production' : 'pilot-resolve'}`
  const devTheme = config.themeId === '196356047183' && theme?.role === 'unpublished'
  const mainTheme = config.themeId === '196921655631' && theme?.role === 'main'
  if (config.enabled !== true || String(theme?.id) !== config.themeId || (!devTheme && !mainTheme) ||
      (mainTheme && !configuredGeneral) || window.Shopify?.designMode || config.attributeName !== attribute || config.endpoint !== configuredEndpoint) return

  if (config.contractVersion !== undefined && ![2, 3].includes(config.contractVersion)) return

  const storageKey = `astari_referral_claim:${config.themeId}:v1`
  const legacyKey = `astari_referral_dev_evidence:${config.themeId}`
  const ttl = 30 * 86400000
  const incoming = new URLSearchParams(window.location.search).getAll('ref')
  const reference = incoming.length === 1 ? incoming[0].toUpperCase() : null
  let storedPilot = false
  if (devTheme && configuredGeneral && config.pilotEnabled === true && incoming.length === 0) {
    try {
      const stored = JSON.parse(window.localStorage.getItem(storageKey) || 'null')
      storedPilot = stored?.code === canonicalCode && stored.mode === 'EVIDENCE_ONLY' && stored.resolverMode !== 'general'
    } catch (_error) {}
  }
  const pilotCompatibility = devTheme && configuredGeneral && config.pilotEnabled === true && (reference === 'LHR63RQJ' || storedPilot)
  const general = configuredGeneral && !pilotCompatibility
  const negotiatedV3 = general && config.contractVersion === 3
  const endpoint = `https://astari-affiliates.vercel.app/api/referral/${general ? 'resolve-production' : 'pilot-resolve'}`
  const applyDiscount = !pilotCompatibility && config.applyDiscount === true
  const safeCode = value => typeof value === 'string' && value.length > 0 && value.length <= 255 && value.trim() === value && value !== '.' && value !== '..' && !/[,\u0000-\u001f\u007f]/.test(value)
  const code = general ? (safeCode(reference) ? reference : null)
    : reference === canonicalCode || reference === 'LHR63RQJ' ? canonicalCode : null
  let queue = Promise.resolve()
  let generation = 0
  let controller
  let processedLink = false
  let evidenceRemoved = false
  let evidenceObserved = false
  let cleanupPending = false
  let privacyLoadState = 'not-loaded'
  let expiryTimer
  let discountPending = false
  let evidencePending = false
  let invitationEvidence
  let discountSubmitted = false
  let resolvedDiscountCode = null
  let discountStaged = false
  let discountNotOffered = false
  let discountTask = Promise.resolve()
  const discountIntentKey = `astari_referral_discount:${config.themeId}:v1`
  let discountReference = reference
  if (applyDiscount && !incoming.length) {
    try {
      const intent = JSON.parse(window.sessionStorage?.getItem(discountIntentKey) || 'null')
      if (intent?.resolverMode === config.resolverMode && safeCode(intent.reference) && intent.expiresAt > Date.now() && intent.expiresAt <= Date.now() + ttl) discountReference = intent.reference
    } catch (_error) {}
  }
  const forgetDiscountIntent = () => { try { window.sessionStorage?.removeItem(discountIntentKey) } catch (_error) {} }
  let resolutionFailed = false
  let evidenceExpiry = null
  let initialStorageState = 'not checked'
  let withdrawalReceived = false
  let finishPrivacy
  const privacyReady = new Promise(resolve => { finishPrivacy = resolve })
  const renderStatus = () => {
    const panel = document.querySelector?.('[data-referral-status-panel]')
    if (!panel) return
    const dataset = document.documentElement.dataset
    const discountLabels = {applied: 'Accepted by cart', rejected: 'Rejected by cart', 'pending-cart': 'Awaiting populated cart', unavailable: 'Unavailable', resolving: 'Resolving invitation', 'not-offered': 'Tracking invitation; no buyer discount offered', 'awaiting-gift-choice': 'Choose the gift or invitation discount'}
    const evidenceLabels = {'captured-evidence-only': 'Submitted to cart; order unverified', 'stored-evidence-present': 'Stored evidence; cart/order unverified', 'settling-consent': 'Waiting for platform consent state', 'awaiting-consent': 'Not captured: consent required', 'invalid-link': 'Invalid invitation', 'no-referral': 'No referral', 'evidence-removed': 'Evidence removed after capture', 'cleanup-pending': 'Cleanup pending; removal unconfirmed', unavailable: 'Unavailable'}
    const values = {mode: pilotCompatibility ? 'Exact pilot compatibility; discounts unchanged' : applyDiscount ? 'Invited discount and signed evidence' : 'Signed evidence only; discounts unchanged',
      discount: discountLabels[dataset.astariReferralDiscount] || 'Not checked on this page',
      evidence: evidenceLabels[dataset.astariReferralPilot] || 'Not captured', consent: withdrawalReceived ? 'Withdrawal received; grant not refreshed' : {granted: 'Granted', declined: 'Declined', unset: 'Not set', unavailable: 'API unavailable', restricted: 'Granted; processing restricted'}[consentState()],
      'privacy-api': privacyLoadState, 'banner-save': dataset.astariConsentPersistence || 'Not reported',
      'storage-at-load': initialStorageState,
      'link-at-load': dataset.astariReferralLink || 'Checking',
      resolver: dataset.astariReferralResolver || 'Not started',
      'local-save': dataset.astariReferralLocalSave || 'Not attempted',
      'local-removal': dataset.astariReferralLocalRemoval || 'None observed',
      'cart-submit': dataset.astariReferralCartSubmit || 'Not attempted',
      'cart-cleanup': dataset.astariReferralCartCleanup || 'Not attempted',
      processed: processedLink ? 'Yes' : 'No', trigger: dataset.astariReferralTrigger || 'Initialization',
      expiry: evidenceExpiry ? new Date(evidenceExpiry).toLocaleString() : 'None',
      checkout: dataset.astariReferralPending === 'true' ? 'Waiting for referral work' : document.querySelector('button[name="checkout"]')?.disabled ? 'Waiting for cart work' : 'Ready'}
    for (const [name, value] of Object.entries(values)) {
      const output = panel.querySelector(`[data-referral-status="${name}"]`)
      if (output) output.textContent = value
    }
  }
  const diagnostic = (name, value) => { document.documentElement.dataset[`astariReferral${name}`] = value; renderStatus() }
  const status = value => { document.documentElement.dataset.astariReferralPilot = value; renderStatus() }
  const discountStatus = value => { document.documentElement.dataset.astariReferralDiscount = value; renderStatus() }
  const pending = value => {
    evidencePending = value
    const busy = evidencePending || discountPending
    document.documentElement.dataset.astariReferralPending = String(busy)
    document.dispatchEvent(new CustomEvent('astari:referral-pending', {detail: {pending: busy}}))
    renderStatus()
  }
  const consentState = () => {
    try {
      const privacy = window.Shopify?.customerPrivacy
      if (!privacy) return 'unavailable'
      const choice = privacy.currentVisitorConsent().marketing
      if (choice === 'no') return 'declined'
      if (choice !== 'yes') return 'unset'
      return privacy.marketingAllowed() === true ? 'granted' : 'restricted'
    } catch (_error) { return 'unavailable' }
  }
  const allowed = () => !withdrawalReceived && consentState() === 'granted'
  const read = key => {
    let raw
    try {
      raw = window.localStorage.getItem(key)
      const value = JSON.parse(raw)
      if (key === storageKey && initialStorageState === 'not checked') initialStorageState = raw === null ? 'missing' : 'present'
      return value
    } catch (_error) {
      if (key === storageKey && initialStorageState === 'not checked') initialStorageState = raw === undefined ? 'unavailable' : 'invalid'
      return {invalid: true}
    }
  }
  const forget = reason => {
    try {
      window.localStorage.removeItem(storageKey); window.localStorage.removeItem(legacyKey)
      diagnostic('LocalRemoval', `Removed locally: ${reason}`)
    } catch (_error) { diagnostic('LocalRemoval', `Removal failed: ${reason}`) }
    evidenceRemoved = false
    evidenceExpiry = null
    renderStatus()
  }
  const validGeneral = evidence => {
    if (evidence.resolverMode !== 'general' || !['STORE_CREDIT', 'CASH'].includes(evidence.program) ||
        !safeCode(evidence.code) || evidence.publicReference !== evidence.code) return false
    try {
      const referral = new URL(evidence.referralUrl)
      if (evidence.referralUrl !== `https://astariwearables.com/?ref=${encodeURIComponent(evidence.publicReference)}` ||
          referral.origin !== 'https://astariwearables.com' || referral.username || referral.password || referral.hash || referral.pathname !== '/') return false
      let buyerCode = evidence.code
      let buyerUrl = evidence.discountUrl
      if (evidence.version === 3) {
        const offer = evidence.discount
        if (!negotiatedV3 || !offer || typeof offer !== 'object' || Array.isArray(offer)) return false
        if (evidence.discountMode === 'TRACKING_ONLY') return evidence.discountAvailable === false &&
          offer.mode === 'NONE' && Object.keys(offer).length === 1 && evidence.discountUrl === undefined
        if (evidence.discountMode !== 'DISCOUNT' || evidence.discountAvailable !== true || offer.mode !== 'SHOPIFY_CODE' ||
            Object.keys(offer).length !== 4 || !safeCode(offer.code) ||
            !(offer.percentage === null || (typeof offer.percentage === 'string' && /^\d{1,3}\.\d{2}$/.test(offer.percentage) &&
              Number(offer.percentage) > 0 && Number(offer.percentage) <= 100)) ||
            (evidence.discountUrl !== undefined && evidence.discountUrl !== offer.url)) return false
        buyerCode = offer.code
        buyerUrl = offer.url
      }
      const discount = new URL(buyerUrl)
      return discount.origin === referral.origin && !discount.username && !discount.password && !discount.hash &&
        discount.pathname === `/discount/${encodeURIComponent(buyerCode)}` && [...discount.searchParams].length === 1 &&
        discount.searchParams.get('redirect') === `/?ref=${encodeURIComponent(evidence.publicReference)}`
    } catch (_error) { return false }
  }
  const valid = evidence => {
    if (!evidence || (general ? ![2, ...(negotiatedV3 ? [3] : [])].includes(evidence.version) || evidence.mode !== 'TRACKING_ONLY' || evidence.scope !== 'REFERRAL_TRACKING'
        : evidence.version !== 1 || evidence.mode !== 'EVIDENCE_ONLY' || evidence.scope !== undefined) ||
        (general ? !validGeneral(evidence) : evidence.code !== canonicalCode || evidence.resolverMode === 'general') ||
        evidence.attributeName !== attribute || typeof evidence.referralClaim !== 'string' || evidence.referralClaim.length > (general ? 4096 : 1024) ||
        !/^[A-Za-z0-9_-]+\.[A-Za-z0-9_-]{43}$/.test(evidence.referralClaim) || typeof evidence.expiresAt !== 'string') return false
    const expiry = Date.parse(evidence.expiresAt)
    return Number.isFinite(expiry) && new Date(expiry).toISOString() === evidence.expiresAt &&
      expiry > Date.now() && expiry <= Date.now() + ttl
  }
  const cartRequest = async (body, signal) => {
    await window.AstariCartReferral?.waitForIdle(signal)
    if (signal.aborted) throw new Error('Referral operation cancelled')
    const root = window.Shopify?.routes?.root || '/'
    if (!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?$/i.test(root)) throw new Error('Invalid cart root')
    const response = await window.fetch(`${root}${body ? 'cart/update.js' : 'cart.js'}`, {
      method: body ? 'POST' : 'GET', credentials: 'same-origin', signal,
      headers: {'Content-Type': 'application/json', Accept: 'application/json'},
      ...(body ? {body: JSON.stringify(body)} : {}),
    })
    if (!response.ok) throw new Error('Referral cart operation failed')
    return response
  }
  const write = async (claim, signal) => {
    const name = claim ? 'CartSubmit' : 'CartCleanup'
    diagnostic(name, 'Pending')
    try {
      const response = await cartRequest({attributes: {[attribute]: claim, __astari_referral_dev_evidence: ''}}, signal)
      diagnostic(name, 'HTTP accepted; private attribute unverified')
      return response
    } catch (error) {
      diagnostic(name, signal.aborted ? 'Aborted' : 'Failed')
      throw error
    }
  }
  const resolve = async (signal, requestedReference = reference) => {
    diagnostic('Resolver', 'Pending')
    try {
      const response = await window.fetch(`${endpoint}?ref=${encodeURIComponent(requestedReference)}${negotiatedV3 ? '&contractVersion=3' : ''}`, {
        method: 'GET', credentials: 'omit', cache: 'no-store', redirect: 'error',
        headers: {Accept: 'application/json'}, signal,
      })
      if (!response.ok) {
        diagnostic('Resolver', 'HTTP rejected')
        throw new Error('Referral resolver unavailable')
      }
      diagnostic('Resolver', 'Validating response')
      const evidence = await response.json()
      if (!valid(evidence) || (negotiatedV3 && evidence.version !== 3) || (general && requestedReference?.toUpperCase() !== evidence.publicReference.toUpperCase())) throw new Error('Invalid referral response')
      diagnostic('Resolver', 'Validated response; signature unverified')
      return evidence
    } catch (error) {
      if (signal.aborted) diagnostic('Resolver', 'Aborted')
      else if (document.documentElement.dataset.astariReferralResolver === 'Pending') diagnostic('Resolver', 'Request failed')
      else if (document.documentElement.dataset.astariReferralResolver === 'Validating response') diagnostic('Resolver', 'Invalid response')
      throw error
    }
  }
  const discountResult = cart => {
    if (discountNotOffered) { discountStatus('not-offered'); return }
    const expectedCode = resolvedDiscountCode || invitationEvidence?.code || (!general ? canonicalCode : null)
    const accepted = expectedCode && cart.discount_codes?.some(entry => entry.code?.toUpperCase() === expectedCode.toUpperCase() && entry.applicable === true)
    discountStatus(accepted ? 'applied' : cart.item_count === 0 ? 'pending-cart' : 'rejected')
  }
  const applyInvitationDiscount = async () => {
    if (!applyDiscount || discountPending || !safeCode(discountReference) || (incoming.length && !code)) return
    discountPending = true
    pending(evidencePending)
    const abort = new AbortController()
    const deadline = window.setTimeout(() => abort.abort(), 8000)
    discountStatus('resolving')
    try {
      invitationEvidence = await resolve(abort.signal, discountReference)
      if (negotiatedV3 && invitationEvidence.discount.mode === 'NONE') {
        discountNotOffered = true
        discountStaged = false
        discountSubmitted = true
        forgetDiscountIntent()
        discountStatus('not-offered')
        return
      }
      discountNotOffered = false
      resolvedDiscountCode = negotiatedV3 ? invitationEvidence.discount.code : invitationEvidence.code
      discountReference = general ? invitationEvidence.publicReference : canonicalCode
      try { window.sessionStorage?.setItem(discountIntentKey, JSON.stringify({resolverMode: config.resolverMode, reference: discountReference, expiresAt: Date.parse(invitationEvidence.expiresAt)})) } catch (_error) {}
      const current = await (await cartRequest(null, abort.signal)).json()
      if (!window.AstariCartReferral?.invitationDiscountAllowed?.(current)) {
        discountStaged = true
        discountStatus('awaiting-gift-choice')
        window.AstariCartReferral?.reflect?.(current)
        return
      }
      discountStaged = false
      const remembered = String(current.attributes?._astari_discount_codes_before_gift || '').split(',')
      const codes = [...(current.discount_codes || []).map(entry => entry.code), ...remembered, resolvedDiscountCode]
        .filter(value => value !== '')
      if (codes.some(value => typeof value !== 'string' || value.length > 255 || /[,\u0000-\u001f]/.test(value))) {
        throw new Error('Existing discounts cannot be preserved')
      }
      const uniqueCodes = [...new Map(codes.map(value => [value.toUpperCase(), value])).values()]
      if (!valid(invitationEvidence) || abort.signal.aborted) throw new Error('Referral resolution expired')
      await cartRequest({discount: uniqueCodes.join(',')}, abort.signal)
      discountSubmitted = true
      forgetDiscountIntent()
      const updated = await (await cartRequest(null, abort.signal)).json()
      discountResult(updated)
      window.AstariCartReferral?.reflect?.(updated)
    } catch (_error) {
      resolutionFailed = !valid(invitationEvidence)
      if (resolutionFailed) forgetDiscountIntent()
      discountStatus('unavailable')
    } finally {
      window.clearTimeout(deadline)
      discountPending = false
      pending(evidencePending)
    }
  }
  const clear = async (signal, reason) => {
    forget(reason)
    cleanupPending = true
    await write('', signal)
    cleanupPending = false
    evidenceObserved = false
  }
  const settleConsent = signal => new Promise((resolve, reject) => {
    const abort = () => { window.clearTimeout(timer); reject(new Error('Consent wait cancelled')) }
    const timer = window.setTimeout(() => { signal.removeEventListener('abort', abort); resolve() }, 2000)
    signal.addEventListener('abort', abort, {once: true})
    if (signal.aborted) abort()
  })
  const run = async (currentGeneration, explicitWithdrawal) => {
    if (currentGeneration !== generation) return
    controller = new AbortController()
    const signal = controller.signal
    const deadline = window.setTimeout(() => controller?.abort(), 8000)
    pending(true)
    window.clearTimeout(expiryTimer)
    try {
      let evidence = read(storageKey)
      if (valid(evidence)) evidenceObserved = true
      if (!explicitWithdrawal && !withdrawalReceived && ['unset', 'unavailable'].includes(consentState())) {
        status('settling-consent')
        await settleConsent(signal)
      }
      if (explicitWithdrawal || !allowed()) {
        if (evidence || read(legacyKey) || incoming.length || cleanupPending || ((processedLink || evidenceObserved) && (explicitWithdrawal || withdrawalReceived))) await clear(signal, explicitWithdrawal || withdrawalReceived || consentState() === 'declined' ? 'withdrawal or decline' : 'consent not granted')
        status('awaiting-consent')
        invitationEvidence = null
        return
      }
      if (incoming.length && !code) {
        await clear(signal, 'invalid invitation')
        status('invalid-link')
        return
      }
      if (evidence && !valid(evidence)) {
        await clear(signal, 'invalid or expired evidence')
        evidence = null
      }
      if (!processedLink && code) {
        if (resolutionFailed) throw new Error('Referral resolver unavailable')
        evidence = valid(invitationEvidence) ? invitationEvidence : await resolve(signal)
      }
      if (!evidence) {
        if (read(legacyKey) || cleanupPending) await clear(signal, 'legacy evidence or cleanup retry')
        evidenceExpiry = null
        if (processedLink) evidenceRemoved = true
        status(evidenceRemoved ? 'evidence-removed' : 'no-referral')
        return
      }
      if (!allowed() || currentGeneration !== generation || signal.aborted) throw new Error('Referral operation cancelled')
      await write(evidence.referralClaim, signal)
      if (!allowed() || currentGeneration !== generation || signal.aborted) throw new Error('Referral operation cancelled')
      diagnostic('LocalSave', 'Pending')
      try { window.localStorage.setItem(storageKey, JSON.stringify({version: evidence.version, code: evidence.code,
        referralClaim: evidence.referralClaim, expiresAt: evidence.expiresAt, attributeName: attribute, mode: evidence.mode,
        ...(general ? {scope: 'REFERRAL_TRACKING', resolverMode: 'general', program: evidence.program, ...(evidence.version === 3 ? {discountMode: evidence.discountMode, discountAvailable: evidence.discountAvailable, discount: evidence.discount} : {discountUrl: evidence.discountUrl}), referralUrl: evidence.referralUrl, publicReference: evidence.publicReference} : {resolverMode: 'pilot'})}))
        window.localStorage.removeItem(legacyKey)
        diagnostic('LocalSave', 'Saved locally')
      } catch (error) { diagnostic('LocalSave', 'Failed'); throw error }
      cleanupPending = false
      processedLink = true
      evidenceRemoved = false
      evidenceExpiry = evidence.expiresAt
      status('captured-evidence-only')
      expiryTimer = window.setTimeout(() => schedule(false, 'expiry timer'), Math.min(2147483647, Date.parse(evidence.expiresAt) - Date.now()))
    } catch (_error) {
      if (currentGeneration !== generation && allowed()) return
      try { await clear(AbortSignal.timeout(1500), !allowed() ? 'consent not granted' : 'operation failed or aborted') } catch (_cleanupError) {}
      status(cleanupPending ? 'cleanup-pending' : 'unavailable')
    } finally {
      window.clearTimeout(deadline)
      if (currentGeneration === generation) pending(false)
    }
  }
  const schedule = (explicitWithdrawal = false, trigger = 'lifecycle') => {
    if (!incoming.length && !read(storageKey) && !read(legacyKey) && !cleanupPending && !((explicitWithdrawal || withdrawalReceived) && (processedLink || evidenceObserved))) {
      status(evidenceRemoved ? 'evidence-removed' : 'no-referral')
      return queue
    }
    diagnostic('Trigger', trigger)
    const currentGeneration = ++generation
    controller?.abort()
    pending(true)
    queue = queue.then(() => discountTask).then(() => privacyReady).then(() => run(currentGeneration, explicitWithdrawal === true))
    return queue
  }
  window.AstariReferralPilot = {refreshStatus: renderStatus, cartChanged: cart => {
    if (discountStaged && !discountPending && window.AstariCartReferral?.invitationDiscountAllowed?.(cart)) discountTask = applyInvitationDiscount()
    else if (discountSubmitted || (!general && cart.discount_codes?.some(entry => entry.code?.toUpperCase() === canonicalCode))) discountResult(cart)
  }, ready: async () => {
    let current
    let currentDiscount
    do { current = queue; currentDiscount = discountTask; await Promise.all([current, currentDiscount]) } while (current !== queue || currentDiscount !== discountTask)
  }}
  document.addEventListener('visitorConsentCollected', event => {
    if (event?.detail?.marketingAllowed === false || consentState() === 'declined') withdrawalReceived = true
    else if (consentState() === 'granted') withdrawalReceived = false
    return schedule(false, 'platform consent event')
  })
  document.addEventListener('astari:consent-status', renderStatus)
  window.addEventListener('storage', event => {
    if (event.key === 'astari_cookie_consent_choice' && event.newValue === 'declined') { withdrawalReceived = true; schedule(true, 'confirmed cross-tab decline'); return }
    if (event.key !== storageKey && event.key !== legacyKey && event.key !== null) return
    diagnostic('Trigger', 'claim storage notification')
    const evidence = read(storageKey)
    if (valid(evidence)) evidenceObserved = true
    if (!evidence && (processedLink || evidenceExpiry)) {
      evidenceRemoved = true
      diagnostic('LocalRemoval', 'External removal observed; cause unknown')
    }
    evidenceExpiry = allowed() && valid(evidence) ? evidence.expiresAt : null
    status(!allowed() ? 'awaiting-consent' : evidenceExpiry ? 'stored-evidence-present' : evidenceRemoved ? 'evidence-removed' : 'no-referral')
  })
  window.addEventListener('pageshow', () => schedule(false, 'pageshow'))
  const initialise = () => {
    if (window.Shopify?.customerPrivacy) { privacyLoadState = 'ready'; finishPrivacy(); schedule(); return }
    if (!window.Shopify?.loadFeatures) { privacyLoadState = 'unavailable'; finishPrivacy(); schedule(); return }
    privacyLoadState = 'loading'
    const deadline = window.setTimeout(() => { privacyLoadState = 'timeout'; finishPrivacy(); schedule() }, 3000)
    if (incoming.length || read(storageKey) || read(legacyKey)) pending(true)
    window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], error => {
      window.clearTimeout(deadline)
      privacyLoadState = window.Shopify?.customerPrivacy ? 'ready' : error ? 'load-failed' : 'unavailable'
      finishPrivacy()
      schedule()
    })
  }
  discountTask = applyDiscount ? applyInvitationDiscount() : Promise.resolve()
  diagnostic('Link', incoming.length === 0 ? 'Absent' : code ? 'Seen; syntax validated' : 'Seen; invalid or ambiguous')
  if (!incoming.length && !read(storageKey) && !read(legacyKey)) { finishPrivacy(); status('no-referral') }
  else initialise()
})()
